<template>
  <div class="home">
    <div class="top">
      <img style="width: 150px" src="http://icon.hhstu.club/logo.jpg" alt="">
    </div>
    <van-row>
      <van-col span="2"></van-col>
      <van-col span="20">
        <van-form @submit="onSubmit">
          <van-field
            right-icon="friends-o"
            clearable
            v-model="stunum"
            name="a"
            label="账号"
            placeholder="账号"
            :rules="[{ required: true, message: '请填写账号' }]"
          />
          <van-field
            right-icon="star-o"
            clearable
            v-model="pwd"
            type="password"
            name="b"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
          <div style="margin: 16px;">
            <van-button round block type="warning" native-type="submit">
              登录
            </van-button>
          </div>
        </van-form>
      </van-col>
      <van-col span="2"></van-col>
    </van-row>
  </div>
</template>

<script>
import Vue from 'vue';
import {Button, Field, Form, Col, Row, Image, Toast} from 'vant';
import {TeaLogin} from "@/network/login";

Vue.use(Image);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(Col);
Vue.use(Row);
export default {
  name: "Teacher",
  data() {
    return {
      stunum: '',
      pwd: '',
    }
  },
  created() {
    if (document.domain.indexOf("fzxy") != -1) {
      TeaLogin(this.$route.query.id, this.$route.query.name, "fzxy").then(res => {
        if (res.islogin) {
          this.$store.commit('logined');
          this.$store.commit('inituser', res);
          this.$cookies.set("islogin", true, '6m');
          this.$cookies.set("user", res.user, '6m');
          this.$cookies.set("info", res.info, '6m');
          this.$router.replace("/home");
        }
      });
    }
  },
  methods: {
    onSubmit(values) {
      this.$bus.$emit('UserLogin', values);
    },
  },
  components: {}
}
</script>

<style scoped>
.home {
  text-align: center;
}

.top {
  padding: 30px;
}
</style>
